module.exports = __webpack_public_path__ + "static/media/sim-card.66d89169.svg";